import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ultimaricerca',
  templateUrl: './ultimaricerca.component.html',
  styleUrls: ['./ultimaricerca.component.css']
})
export class UltimaricercaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
